<template>
  <div class="contentMain">
    <div class="content">
      <div>中国铁道工程建设协会团体标准立项申请书</div>
      <a href="https://carec.oss-cn-beijing.aliyuncs.com/upload/2024/01/29/e1b0ad23-a422-4b4d-bf2c-24486a3a2651.doc">下载</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Group Standard Declaration Download",
  props: {},
  data() {
    return {
      contentType: "list"
    };
  },
  mounted() {

  },
  watch: {
    tabsTypeId: function (val) {
      if (val) {
        this.contentType = "list";
      }
    },
  },
  methods: {
    downloadItem(item) {
      window.open(item.url);
    },
  },
};
</script>

<style scoped>

.contentMain{
  display: flex;
  justify-content: center;
  align-items: center;
  .content{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40px 0;

    >:first-child{
      font-size: 30px;
      color: #333333;
      line-height: 1.8;
      text-align: center;
      font-weight: bold;
    }

    >:last-child{
      font-size: 20px;
      margin-left: 20px;
    }
  }
}
</style>
  